import styled from "styled-components";

export const HeroContainer = styled.div`
  background: ${({ theme }) => theme.bg};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 80px 30px 40px 30px;
  @media (max-width: 960px) {
    padding: 66px 16px 30px 16px;
  }
  @media (max-width: 640) {
    padding: 32px 16px;
  }
  z-index: 1;
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);

  @media (max-width: 960px) {
    justify-content: center;
    padding: 0 0px;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 640px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: end;
  gap: 12px;
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
  }

  @media (max-width: 640px) {
    margin-bottom: 30px;
  }
`;

export const PhotoFrame = styled.div`
  position: relative;
  transform: rotate(-2deg);
  transition: transform 0.4s ease;
  &:hover {
    transform: rotate(0deg) scale(1.02);
  }
`;

export const Img = styled.img`
  position: relative;
  width: 320px;
  height: 320px;
  object-fit: cover;
  filter: grayscale(0.15) contrast(1.05);

  @media (max-width: 640px) {
    width: 220px;
    height: 220px;
  }
`;

export const Title = styled.div`
  font-family: 'Caveat', cursive;
  font-weight: 700;
  font-size: 68px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.05;
  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 48px;
  }
`;

export const NameUnderline = styled.div`
  max-width: 320px;
  margin-top: -6px;
  margin-bottom: 8px;
  @media (max-width: 960px) {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const TextLoop = styled.div`
  font-family: 'Kalam', cursive;
  font-weight: 700;
  font-size: 28px;
  display: flex;
  gap: 12px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.6;
  @media (max-width: 960px) {
    text-align: center;
  }
  @media (max-width: 640px) {
    font-size: 20px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  letter-spacing: 0.5px;
  text-shadow: 0 0 5px ${({ theme }) => theme.primary}77, 0 0 14px ${({ theme }) => theme.primary}33;

  .Typewriter__cursor {
    color: ${({ theme }) => theme.primary};
    font-weight: 400;
    text-shadow: inherit;
  }
`;

export const SubTitle = styled.div`
  font-family: 'Kalam', cursive;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 42px;
  color: ${({ theme }) => theme.text_secondary};

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 32px;
  }
`;


export const ResumeButton = styled.a`
    display: inline-block;
    text-decoration: none;
    text-align: center;
    color: ${({ theme }) => theme.text_primary};
    cursor: pointer;
    font-family: 'Kalam', cursive;
    font-size: 20px;
    font-weight: 700;
    transition: transform 0.15s ease-in-out;
    background-color: transparent;
    position: relative;

    &:hover {
        transform: rotate(-1deg) scale(1.04);
    }

    @media (max-width: 640px) {
        padding: 12px 20px;
        font-size: 18px;
    }
`;
